import useComments from "backend/hooks/comments/useComments";
import useYearsLastPeriod from "backend/hooks/model/useYearsLastPeriod";
import { ICardElementWithChildren } from "backend/model/model";
import React from "react";
import DomElement from "reportengine/DomElement";
import TextElement from "reportengine/TextElement";
import { t } from "i18next";

//   const lastPeriod = useYearsLastPeriod(ctx.period || "");

const ReportComments = (
  props: React.PropsWithChildren<{
    item: ICardElementWithChildren;
    slideElement: string;
    justificationOwnerNameElement: string;
    justificationOwnerElement: string;
    justificationDateElement: string;
  }>
) => {
  const { data: comments, isLoading } = useComments({
    id: props.item.id,
    period: props.item.period?.name || "",
  });

  if (!isLoading) {
    console.log("Report comments", comments);
  }
  // justification_owner
  // justification_owner_name
  // justification_date
  return (
    <>
      <TextElement slideElement="justification_title">
        {t("strategyReport.Actions and Recommendations")}
      </TextElement>
      <TextElement slideElement={props.justificationOwnerElement}>
        {t("strategyReport.Owner")}
      </TextElement>
      <DomElement
        slideElement={props.justificationOwnerNameElement}
        selector=".txt"
        typename="text"
      >
        {!isLoading ? (
          <div className="txt">
            {comments?.[0]?.modifiedby || comments?.[0]?.createdby || ""}
          </div>
        ) : null}
      </DomElement>
      <DomElement
        slideElement={props.justificationDateElement}
        selector=".txt"
        typename="text"
      >
        {!isLoading ? (
          <div className="txt">
            {comments?.[0]?.lastmodifieddate
              ? new Date(comments?.[0]?.lastmodifieddate).toLocaleDateString()
              : ""}
          </div>
        ) : null}
      </DomElement>
      <DomElement
        slideElement={props.slideElement}
        selector=".txt"
        typename="html"
      >
        {!isLoading ? (
          <div
            className="txt"
            dangerouslySetInnerHTML={{
              __html: comments?.[0]?.description || "",
            }}
          />
        ) : null}
      </DomElement>
    </>
  );
};

export default ReportComments;
